/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CountryCodeEnum } from '../../models/country-code-enum';

export interface LanguageAdd$Params {
  productId: string;
  language?: CountryCodeEnum;
}

export function languageAdd(http: HttpClient, rootUrl: string, params: LanguageAdd$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, languageAdd.PATH, 'post');
  if (params) {
    rb.path('productId', params.productId, {});
    rb.query('language', params.language, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

languageAdd.PATH = '/api/Language/{productId}';
